export default "__VITE_ASSET__5xenZRUJ__"